import { getStore } from '../store/store';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { SearchApp } from '@msfast/search-hostapp-owa';
import { SearchTableQuery } from 'owa-mail-list-search';
import { TableQueryType } from 'owa-mail-list-store';
import TableQuery from 'owa-mail-list-store/lib/store/schema/TableQuery';
import { ErrorBoundary, ErrorComponentType } from 'owa-error-boundary';
import { TraceErrorObject, errorThatWillCauseAlert } from 'owa-trace';
import { logUsage } from 'owa-analytics';
import getSelectedSearchScope from '../utils/getSelectedSearchScope';
import getFolderNameFromScope from '../utils/getFolderNameFromScope';
import { SearchBitFlagsMasks, getIsBitSet } from 'owa-bit-flags/lib/utils/searchBitFlagsUtil';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getScenarioStore, SearchScenarioId } from 'owa-search';

export interface AnswerContainerProps {
    tableQuery: TableQuery;
    isRenderingInMailListEmptyState?: boolean;
}

export default observer(function AnswersContainer(props: AnswerContainerProps) {
    const searchScope = getSelectedSearchScope();
    const folderName = searchScope && getFolderNameFromScope(searchScope);
    const isDefaultScopeSetToInboxFolder =
        isFeatureEnabled('sea-inboxScopeSetting') &&
        getIsBitSet(SearchBitFlagsMasks.ScopeInboxSearchToFolder);

    // We only want to show Answers if we are in the Search mail table type
    // and we're searching in the default scope (either "All" or "Inbox" folder) set
    // by the user in settings.
    if (
        props.tableQuery.type != TableQueryType.Search ||
        (isDefaultScopeSetToInboxFolder && folderName !== 'inbox') ||
        (!isDefaultScopeSetToInboxFolder && folderName !== 'msgfolderroot')
    ) {
        return null;
    }

    const reportAnswerComponentError = (error: TraceErrorObject, errorInfo: React.ErrorInfo) => {
        error.diagnosticInfo = errorInfo.componentStack;
        errorThatWillCauseAlert(`[Answers] Wrapper Component error: ${error.message}`, error);
    };

    const searchTableQuery = props.tableQuery as SearchTableQuery;
    const query = searchTableQuery.queryString;
    const isAnswerInitialized = getStore().isAnswerInitialized;
    const { currentSearchQueryId } = getScenarioStore(SearchScenarioId.Mail);

    if (query && isAnswerInitialized) {
        if (props.isRenderingInMailListEmptyState) {
            logUsage('Search_SearchAnswerInMailListEmptyStateRendered', {
                logicalId: currentSearchQueryId,
            });
        }
        logUsage('Search_Answers_AnswerRenderingStart', {
            logicalId: currentSearchQueryId,
        });
        return (
            <ErrorBoundary
                onError={reportAnswerComponentError}
                suppressErrorReport={true}
                type={ErrorComponentType.None}>
                <div
                    style={{
                        width: '100%',
                    }}>
                    <SearchApp query={query} />
                </div>
            </ErrorBoundary>
        );
    } else {
        return null;
    }
});
